import { Layout } from "@/components/layout/Layout";
import { HeroSection } from "@/components/home/HeroSection";
import { PartnersBanner } from "@/components/home/PartnersBanner";
import { PackagesPreview } from "@/components/home/PackagesPreview";
import { ServicesLinks } from "@/components/home/ServicesLinks";

import { Testimonials } from "@/components/home/Testimonials";
import { ConsultationForm } from "@/components/home/ConsultationForm";
import { FinalCTA } from "@/components/home/FinalCTA";
import { SEO } from "@/components/SEO";
import { organizationSchema, siteNavigationSchema } from "@/lib/structuredData";

const Index = () => {
  return (
    <Layout>
      <SEO 
        title="Bookkeeping Services South Africa | SAICA Registered Accountants"
        description="Outsourced bookkeeping services for South African businesses. SAICA registered accountants handling Xero, Sage & Pastel, payroll, VAT and full SARS compliance from R2,500/month."
        canonical="/"
        structuredData={[organizationSchema, siteNavigationSchema]}
      />
      <HeroSection />
      <PartnersBanner />
      <PackagesPreview />
      <ServicesLinks />
      
      
      <Testimonials />
      <ConsultationForm />
      <FinalCTA />
    </Layout>
  );
};

export default Index;
